/* eslint-disable no-tabs */
import _ from 'lodash';
// eslint-disable-next-line object-curly-newline
import { useEffect, useMemo, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { connect } from 'react-redux';
import ProductDetails from '../../../Components/Forms/Products/ProductDetails';
import { CreatePageHeader } from '../../../Components/Headers';
import productConfig from './allproduct.config';
import { FormSectionHeader } from '../../../Components/Forms';
// eslint-disable-next-line object-curly-newline
import { inputHelper, isEmpty } from '../../../Helpers';
import { formActions } from '../../../Actions';
import ProductTags from '../../../Components/Forms/ProductTags/ProductTags';
import { notificationServices } from '../../../Services';
import { useAuth } from '../../../Components/Auth/Login/auth';
import productSubCategoryServcies from '@/Services/Form Services/productSubCategoryServcies';
import { urls } from '@/Constants';

const ProductCreatePage = (props) => {
	const { appConfig = {} } = useAuth();
	const { measurement } = appConfig?.configs ?? {};
	// eslint-disable-next-line object-curly-newline
	const {
		isEdit,
		saveProduct,
		fetchProduct,
		data,
		limit,
		breadcrumbs,
		brands,
	} = props;

	const disabledUnits =
		measurement === 'US' ? ['gram', 'litre', 'ml'] : ['oz', 'floz'];

	const [state, setState] = useState({
		...productConfig.initialState,
		fields: {
			...productConfig.initialState?.fields,
			densityUnit: measurement === 'US' ? 'Lb' : 'Kg',
			productUnits:
				productConfig.initialState?.fields?.productUnits?.filter(
					(ele) => {
						return !disabledUnits?.includes(ele?.id);
					}
				),
		},
	});
	const [numberOfSubmissions, setNumberOfSubmissions] = useState(0);
	const [disableUnit, setDisableUnit] = useState(true);
	const [subCategoriesList, setSubCategoriesList] = useState([]);

	const { id } = useParams();

	useEffect(() => {
		if (isEdit) {
			if (!isEmpty(data) && data?.id === id) {
				setState(
					productConfig.serializer(state, {
						...data,
						measurement,
						densityUnit: measurement === 'US' ? 'Lb' : 'Kg',
					})
				);
			} else {
				fetchProduct({
					entity: 'ALL_PRODUCTS',
					req: {
						params: {
							id,
						},
					},
					method: 'VIEW',
				});
			}
		}
	}, []);

	const fetchSubCategories = async () => {
		try {
			const response =
				await productSubCategoryServcies.listProductSubCategory({
					req: {
						params: {
							categoryId: state?.fields?.category,
						},
					},
				});
			if (response?.statusCode === 200) {
				setSubCategoriesList(response?.data);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};

	useEffect(() => {
		if (state?.fields?.category) {
			fetchSubCategories();
		}
	}, [state?.fields?.category]);

	useEffect(() => {
		if (isEdit) {
			if (!isEmpty(data) && numberOfSubmissions === 0) {
				setState(
					productConfig.serializer(state, {
						...data,
						measurement,
						densityUnit: measurement === 'US' ? 'Lb' : 'Kg',
					})
				);
			}
		}
	}, [data]);

	// useEffect(() => {
	// 	if (state?.fields?.category) {
	// 		fetchSubCategories({
	// 			entity: 'PRODUCT_SUB_CATEGORY',
	// 			req: {
	// 				params: {
	// 					categoryId: state?.fields?.category,
	// 				},
	// 			},
	// 			method: 'LIST',
	// 		});
	// 	}
	// }, [state?.fields?.category]);

	const handleFileInput = (e) => {
		const { fieldName } = inputHelper(e);
		const file = e.target.files[0];
		switch (fieldName) {
			case 'image':
				setState(
					_.update(_.cloneDeep(state), `fields[${fieldName}]`, () => {
						return file;
					})
				);
				break;
			default:
				break;
		}
	};

	const handleImageInput = (fieldName, blob) => {
		setState(
			_.update(_.cloneDeep(state), `fields[${fieldName}]`, () => {
				return blob;
			})
		);
	};

	const handleInput = (e) => {
		const { fieldName, fieldValue, dataset } = inputHelper(e);
		const newState = {};
		let haveUnit = false;
		// for form validations and error generation
		switch (fieldName) {
			case 'veg':
				newState[fieldName] = fieldValue === '1';
				break;
			case 'productClass':
				newState[fieldName] = state.fields.productClass.map(
					(productClassObject, idx) => {
						if (idx === parseInt(dataset.id, 10)) {
							return {
								...productClassObject,
								isApplied: fieldValue,
							};
						}
						return {
							...productClassObject,
							isApplied: false,
						};
					}
				);
				newState.purchaseUnits = state.fields.purchaseUnits.map(
					(productUnitObject) => {
						return {
							...productUnitObject,
							isApplied: false,
						};
					}
				);
				break;
			case 'category':
				newState.productUnits = state.fields.productUnits.map(
					(productUnitObject) => {
						if (
							productUnitObject.id ===
							brands[state.fields.brand].ProductCategory[
								fieldValue
							]?.unit
						) {
							newState.perUnit =
								productUnitObject?.id === 'floz'
									? 'Gal'
									: 'ltr';
							haveUnit = true;
							return {
								...productUnitObject,
								isApplied: true,
							};
						}
						return {
							...productUnitObject,
							isApplied: false,
						};
					}
				);
				break;
			case 'productUnits':
				newState[fieldName] = state.fields.productUnits.map(
					(productUnitObject, idx) => {
						if (idx === parseInt(dataset.id, 10)) {
							newState.perUnit =
								productUnitObject?.id === 'floz'
									? 'Gal'
									: 'ltr';
							return {
								...productUnitObject,
								isApplied: fieldValue,
							};
						}
						return {
							...productUnitObject,
							isApplied: false,
						};
					}
				);
				break;
			case 'purchaseUnits':
				newState[fieldName] = state.fields.purchaseUnits.map(
					(productUnitObject, idx) => {
						if (idx === parseInt(dataset.id, 10)) {
							return {
								...productUnitObject,
								isApplied: fieldValue,
							};
						}
						return {
							...productUnitObject,
							isApplied: false,
						};
					}
				);
				break;
			default:
				break;
		}
		if (fieldName === 'category') {
			setDisableUnit(haveUnit);
		}
		setState({
			...state,
			fields: {
				...state.fields,
				[fieldName]: fieldValue,
				...newState,
			},
		});
	};
	const includeTag = (e) => {
		const { dataset } = inputHelper(e);
		switch (dataset.type) {
			case 'menu':
				setState(
					_.update(
						_.cloneDeep(state),
						'fields.menuTags',
						(menuTags) => {
							const newMenuTags = menuTags;
							const index = newMenuTags.indexOf(dataset.tag);
							if (index === -1) {
								if (newMenuTags.length >= limit) {
									notificationServices.generateNotification({
										type: 'error',
										message:
											"can't add more than 3 menu tags",
									});
								} else {
									newMenuTags.push(dataset.tag);
								}
							} else {
								newMenuTags.splice(index, 1);
							}
							return newMenuTags;
						}
					)
				);
				break;
			case 'product':
				setState(
					_.update(
						_.cloneDeep(state),
						'fields.productTags',
						(productTags) => {
							const newProductTags = productTags;
							const index = newProductTags.indexOf(dataset.tag);
							if (index === -1) {
								if (newProductTags.length >= limit) {
									notificationServices.generateNotification({
										type: 'error',
										message:
											"can't add more than 3 products tags",
									});
								} else {
									newProductTags.push(dataset.tag);
								}
							} else {
								newProductTags.splice(index, 1);
							}
							return newProductTags;
						}
					)
				);
				break;
			default:
				break;
		}
	};
	const handleSave = (e) => {
		e.preventDefault();
		const isValid = productConfig.validator(state);
		if (isValid) {
			setNumberOfSubmissions(numberOfSubmissions + 1);
			productConfig.deserializer(state).then((req) => {
				if (isEdit) {
					req.params = {
						id,
					};
					saveProduct({
						entity: 'ALL_PRODUCTS',
						req,
						method: 'UPDATE',
						redirect: `${urls.EXTENSION}${urls.ALL_PRODUCTS}`,
					});
				} else {
					saveProduct({
						entity: 'ALL_PRODUCTS',
						req,
						method: 'CREATE',
						redirect: `${urls.EXTENSION}${urls.ALL_PRODUCTS}`,
					});
				}
			});
		}
	};

	const generateDefaultOption = (type, brand, category, subcategory) => {
		switch (type) {
			case 'brand':
				if (!brand || brand.length === 0) {
					return (
						<option value={null} selected disabled hidden>
							Select a Brand
						</option>
					);
				}
				break;
			case 'category':
				if (brand) {
					if (!category || category.length === 0) {
						return (
							<option value={null} selected disabled hidden>
								Select a Category
							</option>
						);
					}
				} else {
					return (
						<option value={null} selected disabled hidden>
							Select a Brand First
						</option>
					);
				}
				break;
			case 'subCategory':
				if (category) {
					if (!subcategory || subCategoriesList?.length === 0) {
						return (
							<option value={null} selected disabled hidden>
								Select a Sub Category
							</option>
						);
					}
				}
				return (
					<option value={null} selected disabled hidden>
						Select a Category First
					</option>
				);
			default:
				break;
		}
		return <></>;
	};
	const history = useHistory();
	const handleCancel = () => {
		if (isEdit) {
			history.push(`${urls.EXTENSION}${urls.ALL_PRODUCTS}/view/${id}`);
		} else {
			history.push(`${urls.EXTENSION}${urls.ALL_PRODUCTS}`);
		}
	};

	const excludedFields = useMemo(() => {
		let exclude = {};
		const productUnit = state?.fields?.productUnits?.reduce(
			(finalUnit, currUnit) => {
				if (currUnit?.isApplied) {
					return currUnit?.id;
				}
				return finalUnit;
			},
			''
		);

		if (
			productUnit === 'litre' ||
			productUnit === 'ml' ||
			productUnit === 'floz'
		) {
			exclude = {};
		} else {
			exclude.productDensity = true;
		}
		return exclude;
	}, [state?.fields?.productUnits]);

	return (
		<div className='root'>
			<form onSubmit={handleSave}>
				<CreatePageHeader
					heading={isEdit ? 'Edit Product' : 'Create Product'}
					handleSave={handleSave}
					handleCancel={handleCancel}
					breadcrumbs={[
						...breadcrumbs,
						{
							link: '',
							name: isEdit
								? `Edit ${state.fields.name}`
								: 'Create new',
						},
					]}
					showBreadcrumbs
				/>
				<FormSectionHeader
					tooltip='description for the section'
					sectionName='General Details'
				>
					<ProductDetails
						mandatoryFields={productConfig.mandatoryFields}
						fields={state.fields}
						handleFileInput={handleFileInput}
						handleImageInput={handleImageInput}
						generateDefaultOption={generateDefaultOption}
						handleInput={handleInput}
						exclude={excludedFields}
						disableUnit={disableUnit}
						subCategoriesList={subCategoriesList}
					/>
				</FormSectionHeader>
				<FormSectionHeader tooltip='tags' sectionName='Tags'>
					<ProductTags
						fields={state.fields}
						menuTags={state.menuTags}
						productTags={state.productTags}
						handleClick={includeTag}
					/>
				</FormSectionHeader>
			</form>
		</div>
	);
};

const mapStateToProps = (state) => {
	const data = state.form.ALL_PRODUCTS.data.VIEW;
	const { brands } = state.brand;
	return {
		brands,
		data,
	};
};
const mapDispatchToProps = {
	saveProduct: formActions.gateway,
	fetchProduct: formActions.gateway,
};
ProductCreatePage.defaultProps = {
	limit: 3,
};
export default connect(mapStateToProps, mapDispatchToProps)(ProductCreatePage);
